import Vue from 'vue'
import user from './user'
import filters from './filters'
import activityLog from './activity-log'
import appliesFilters from './applies-filters'
import { get } from 'vuex-pathify'
export { default as echo } from './echo'

export {
    user,
    filters,
    activityLog,
    appliesFilters
}

Vue.mixin({
  computed: {
    ...get('user', {
      $user: 'authorized',
      $can: 'can',
      $cannot: 'cannot',
      $isA: 'isA',
      $isNotA: 'isNotA'
    })
  }
})
